export default {"src":"/_next/static/media/manabr.85b01857.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};